export default __webpack_public_path__ + "static/media/back.a5c58493.svg";